import { Fragment } from "react";
import { useSelector } from "react-redux";

// Inner Components
import CsvUploadAndErrorDetails from "./CsvUploadAndErrorDetails";
import NoContentImportCSV from "./NoContentImportCSV";

// Constants
import { ERROR_STATUS } from "../../../../constants/GlobalConstants";

const CsvErrorUploadStatus = ({ isError }) => {
  const uploadedAndErrorFiles = useSelector(
    (state) => state.csvImportExportReducer?.uploadedAndErrorFiles
  );

  const errorFiles =
    uploadedAndErrorFiles?.filter((file) => file.status === ERROR_STATUS) || [];

  return (
    <>
      {errorFiles?.length > 0 ? (
        errorFiles.map((errorCsvDetails, index) => (
          <Fragment key={errorCsvDetails.csvUploadId ?? index}>
            <CsvUploadAndErrorDetails
              uploadDetails={errorCsvDetails}
              index={index}
              isUploadingCSV
              isError={isError}
            />
            {errorFiles?.length - index > 1 && <hr />}
          </Fragment>
        ))
      ) : (
        <NoContentImportCSV />
      )}
    </>
  );
};

export default CsvErrorUploadStatus;
